import { Box, Typography } from '@mui/material';
import { tokens } from '../theme';
import GooeyNav from '../reactbits/GooeyNav';

const items = [
  { label: 'About', href: '#mission' },
  { label: 'Focus', href: '#focus' },
  { label: 'Contact', href: '#contact' },
];

export default function Nav() {
  return (
    <Box
      component="nav"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 2.5, md: 7 },
        py: 2.75,
      }}
    >
      <Typography sx={{ fontFamily: tokens.display, fontWeight: 600, fontSize: '1.15rem', letterSpacing: '0.03em', color: tokens.paper }}>
        EWAS
        <Box component="span" sx={{ color: tokens.ember }}>.</Box>
      </Typography>

      <GooeyNav items={items} accentColor={tokens.frost} textColor={tokens.paperDim} activeTextColor={tokens.ink} />
    </Box>
  );
}
